<template>
  <div id="app">
    <router-view v-if="show"></router-view>
  </div>
</template>

<script>
import Util from '@/utils/utils';
import API from '@/api/common';
import TYPE from '@/store/types';
import { mapGetters } from 'vuex';
export default {
  name: 'App',
  components: {},
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters({
      isAppLogin: 'isLogin'
    })
  },
  mounted() {
    //未登陆，则自动登陆
    if (!this.isAppLogin) {
       this.show = true;
     // this.autoLogin();
    }
  },
  methods: {
    autoLogin() {
      //本地缓存有用户信息
      if (Util.getUser()) {
        if (Util.getToken()) {
          this.show = true;
        } else {
          Util.clear();
          this.wxLogin();
        }
      } else {
        this.wxLogin();
        // this.setDefaultUser();
      }
    },
    wxLogin() {
      //微信登陆方式
      //其次抓url参数
      let code = Util.getQueryString('code');
      code = "jaketest";
      if (code) {
        //用户登陆
        API.findUserCode(
          process.env.VUE_APP_CORPID,
          process.env.VUE_APP_AGENTID,
          code,
        ).then(res => {
          console.info(res);
          this.show = true;
          this.$store.commit(TYPE.SET_TOKEN, res.token);
          this.$store.commit(TYPE.SET_USER_INFO, res.userInfo);
          this.$store.commit(TYPE.SET_LOGIN, true);
          Util.setToken(res.token);
          console.info(res.userInfo.productType)
          Util.setUser({
              userCode: res.userInfo.userCode,
              userName: res.userInfo.userName,
              productType: res.userInfo.productType == null ? '' : res.userInfo.productType,
              regionCode: res.userInfo.regionCode
          });
          console.info(Util.getUser());
          Util.setTokenTime(res.tokenTime);
          console.log(Util.getRedirectPath());
          console.log(res.token);
          if (Util.getRedirectPath()) {
            window.location.href = Util.getRedirectPath();
          }
        });
      } else {
        //未从微信处获取到对应的信息，则跳转
        this.wxRedirect();
      }
    },
    //认证跳转
    wxRedirect() {
      let href = location.href;
      // const href = "http://wx.dafaland.com:85/mobile/#/news";
      Util.setRedirectPath(href);
      const appId = process.env.VUE_APP_CORPID;
      // encodeURIComponent(href)
      const redirect = process.env.VUE_APP_WEIXIN_SHARE_URL.replace(
        '#APPID',
        appId
      )
        .replace('#URL', href)
        .replace('#STATE', appId);
      console.log(redirect);
      window.location.href = redirect;
    },
    // 默认用户设置
    setDefaultUser() {
      Util.setUser('chenhw');
      API.findDefaultUserCode().then(res => {
          this.show = true;
          this.$store.commit(TYPE.SET_TOKEN, res.token);
          this.$store.commit(TYPE.SET_USER_INFO, res);
          this.$store.commit(TYPE.SET_LOGIN, true);
          Util.setToken(res.token);
          Util.setUser({ userCode: res.userCode, userName: res.userName });
          Util.setTokenTime(res.tokenTime);
          console.log(Util.getRedirectPath());
          console.log(res.token);
          if (Util.getRedirectPath()) {
            window.location.href = Util.getRedirectPath();
          }
        });
    }
  }
};
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
  background-color: #f7f7f7;
}
</style>
